import styled from 'styled-components';
import theme from '../../../../../styles/theme';
import Button from '../../../../common/Button';
import moment from 'moment';

import React, { useCallback, useState, useEffect } from 'react';

import { Row } from '../../../../../styles/common';
import { FormControl, Select, InputLabel, TextField, MenuItem } from '@mui/material';
import { useGetCodeList } from '../../../../../interface/common';
import CommonDataGrid from '../../../../common/CommonDataGrid';
import { useQuery } from 'react-query';
import { useGetInspectHistSel, useGetInspectInfo, useSetInspect } from '../../../../../interface/inspect';
import { useParams } from 'react-router-dom';
import FullModal from '../../../../common/modal/FullModal';
import MsgModal from '../../../../common/modal/MsgModal';
import InspectHistItem from './InspectHistItem';


const MainWrap = styled.div`
    padding: 0.25rem 1.5rem; 
    h3 {
        // display: inline-box;
        font-size: ${theme.fontSize.base};
        font-weight: 600;
        // width: calc(100% - 24px);
        margin: 0;
        
        color: ${theme.color.black};
    }
    div {
        // width: calc(100% - 24px);
        // padding: 12px;
        color: ${theme.color.black};
        font-size: ${theme.fontSize.base};
    }
    transition: ${theme.windowSize.drawerTransition};
`;

const columns = [
    { field: 'tno', headerName: '자산번호', flex: 0.5 },
    { field: 'ret_stnm', headerName: '상태', flex: 0.5 },
    { field: 'model_nm', headerName: '모델명', flex: 0.5 },
    { field: 'contents', headerName: '내용', flex: 0.5 },
    { field: 'descr', headerName: '비고', flex: 0.5 },
    { field: 'reg_dt', headerName: '등록일',valueGetter: (param) => moment(param.reg_dt).format('YYYY/MM/DD') ,flex: 0.5 },
]


const InspectHistMain = () => {
    const param = useParams();
    const {data:pItem, isSuccess} = useGetInspectInfo({sno:param.sno});

    const [sendItem, setSendItem] = useState({});

    const { mutate, error } = useSetInspect();
    const {data : ispTpList} = useGetCodeList('isp_tp');
    const {data : ispKdList} = useGetCodeList('isp_kd');
    const {data : ispStList} = useGetCodeList('isp_st');

    const {data, isLoading } = useGetInspectHistSel({sno:param.sno});
    const [list, setList] = useState([]);

    const { data : user } = useQuery('ADMIN_USER_INFO', {});

    const [errorMsg, setErrorMsg] = useState();
    const [toggle,setToggle] = useState(false);
    const [itemOpen,setItemOpen] = useState(false);

    const [targetSelect, setTargetSelect] = useState();

    useEffect(()=>{
        if(isSuccess && pItem && pItem[0]){
            const target = pItem[0];
            setSendItem(target);
        }
    },[pItem])
    const handleValueChange = (id, val) => {
        setSendItem({...sendItem,[id]:val});
    }

    const handleModClick = useCallback((param) => {
        mutate(
            {...param,mode:'PUT'},
            // {
            //     onSuccess:()=>{
            //         setToggle(true);
            //         setErrorMsg('수정 되었습니다.');
            //     },
            //     onError:(e)=>{
            //         setToggle(true);
            //         setErrorMsg('수정 실패하였습니다.',e);
            //     }
            // }
        );
    },[mutate]);

    const handleDelClick = useCallback(() => {
        const delParam = {
            mode: 'DELETE',
            sno: param.sno
        }
        mutate(delParam);
    },[mutate]);

    useEffect(()=>{
        if(error && error !== null && error.response && error.response.data){
            setErrorMsg(error.response.data.message)
        }
    },[error])

    useEffect(()=>{
        if(data){
            setList(data.map((item,index)=>({...item,id:index})));
        }else{
            setList([])
        }
    },[data])

    return (isSuccess && pItem[0]) ? (
        <MainWrap>
            <div 
                style={{
                    flexGrow:1,
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'flex-start'
                }}
            >
                <Row style={{marginTop:'8px'}}>
                    <TextField
                        id='isp_nm'
                        label='조사명'
                        size='small'
                        // defaultValue={pItem[0].isp_nm}
                        value={sendItem.isp_nm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <FormControl style={{width:'8rem'}} size='small'>
                        <InputLabel id='ispSt-label'>진행상태</InputLabel>
                        <Select label="진행상태" labelId='ispSt-label' size='small' defaultValue={pItem && pItem[0].isp_st}>
                            {ispStList && ispStList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('isp_st',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='ispTp-label'>조사유형</InputLabel>
                        <Select label="조사유형" labelId='ispTp-label' size='small' defaultValue={pItem && pItem[0].isp_tp}>
                            {ispTpList && ispTpList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('isp_tp',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <FormControl style={{width:'10rem'}} size='small'>
                        <InputLabel id='ispKd-label'>조사대상</InputLabel>
                        <Select label="조사대상" labelId='ispKd-label' size='small' defaultValue={pItem && pItem[0].isp_kd}>
                            {ispKdList && ispKdList.map((item,index)=>{
                                return <MenuItem 
                                            key={index} 
                                            value={item.code} 
                                            onClick={()=>handleValueChange('isp_kd',item.code)}
                                        >
                                            {item.value}
                                        </MenuItem>
                            })}
                        </Select>
                    </FormControl>
                    <div style={{flexGrow:1}} />
                    <div style={{display:'grid', alignItems:'center', gridTemplateColumns:'100px 100px'}}>
                            <Button onClick={()=>handleModClick(sendItem)}>수정</Button>
                            <Button onClick={handleDelClick}>삭제</Button>
                    </div>
                </Row>
                <Row>
                    <TextField 
                        id='sdate'
                        label='조사기간(시작)' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small' 
                        defaultValue={pItem && moment(pItem[0].sdate).format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='edate'
                        label='조사기간(종료)' 
                        style={{width:'10rem'}} 
                        InputLabelProps={{shrink:true}} 
                        type='date' 
                        size='small'
                        defaultValue={pItem && moment(pItem[0].edate,'YYYYMMDD').format('YYYY-MM-DD')}
                        onChange={(e)=>handleValueChange(e.target.id,moment(e.target.value,'YYYY-MM-DD').format('YYYYMMDD'))}
                    />
                    <TextField 
                        id='reg_nm'
                        label='등록자' 
                        disabled
                        style={{width:'6rem'}} 
                        InputLabelProps={{shrink:true}} 
                        InputProps={{
                            readOnly: true,
                          }}
                        type='text' 
                        size='small' 
                        defaultValue={pItem ? pItem[0].reg_nm : user.user_nm}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='contents' 
                        label='조사내용' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        value={sendItem.contents}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr' 
                        label='비고' 
                        fullWidth 
                        multiline 
                        rows={2} 
                        size='small' 
                        value={sendItem.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>

                {pItem && 
                <Row style={{justifyContent:'space-between'}}>
                    <div>전체 개수 : {list ? list.length : 0}</div>
                    <Button onClick={()=>{setTargetSelect({});setItemOpen(true)}} style={{width:'100px'}}>추가</Button>
                </Row>
                }
                {pItem &&
                <div style={{width:'100%', height: '54vh'}}>
                <CommonDataGrid
                    isLoading={isLoading}
                    list={list}
                    columns={columns}
                    onRowClick={(e)=>{setTargetSelect(e.row);setItemOpen(true)}}
                />
                </div>
                }
            </div>
            {
                <MsgModal open={toggle}>
                    <div onClick={()=>setToggle(false)}>
                        {errorMsg}
                    </div>
                </MsgModal>
            }
            {
                <FullModal open={itemOpen}>
                    <MngItem sno={pItem[0].sno} target={targetSelect} ispNm={pItem[0].isp_nm} onClose={setItemOpen} />
                </FullModal>
            }
        </MainWrap>
    ) :<React.Fragment />
}

export default InspectHistMain;

const DetailWrapStyle = styled.div`
    width: 100%;
    height: 100%;
    // border: 1px solid red;
`;



const MngItem = ({sno, target, ispNm, onClose}) => {
    return (
        <DetailWrapStyle>
            <InspectHistItem sno={sno} target={target} ispNm={ispNm} onClose={onClose} />
        </DetailWrapStyle>
    )

}